<template>
	<div class="d-flex flex-column align-center">
		<div class="icon-container d-flex justify-center bg-neutral-50 rounded-1">
			<Icon class="text-neutral-900 align-self-center" icon="bell" radius="21px" />
		</div>
		<h3 class="mt-3 text-title-s text-neutral-900">
			{{ $t('web.home.notifications.empty_state_title') }}
		</h3>
		<p class="mt-1 text-body-m text-neutral-900">
			{{ $t('web.home.notifications.empty_state_description') }}
		</p>
	</div>
</template>
<style lang="scss" scoped>
	.icon-container {
		width: 34px;
		height: 34px;
	}
</style>
